import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=29dfecde"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29dfecde')) {
      api.createRecord('29dfecde', component.options)
    } else {
      api.reload('29dfecde', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=29dfecde", function () {
      api.rerender('29dfecde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/entryDesign/comment.vue"
export default component.exports